import React from 'react'

const Skeleton = ({ width = '100%', height = 14, radius, className = '', style }) => (
    <span
        className={`mv-skeleton ${className}`}
        style={{ width, height, borderRadius: radius, ...style }}
        aria-hidden='true'
    />
)

export const ProductCardSkeleton = () => (
    <div className='mv-skeleton-card' aria-hidden='true'>
        <Skeleton className='mv-skeleton-media' height='auto' />
        <div className='mv-skeleton-lines'>
            <Skeleton width='85%' />
            <Skeleton width='45%' />
        </div>
    </div>
)

export const ProductGridSkeleton = ({ count = 8 }) => (
    <div className='mv-product-grid' role='status' aria-label='Loading products'>
        {Array.from({ length: count }, (_, i) => <ProductCardSkeleton key={i} />)}
    </div>
)

export default Skeleton
